import { createContext } from "react";
import { AudioSettings } from "./types";

export const AudioSettingsContext = createContext<AudioSettings>({
  shouldMuteMedia: false,
});
